import React from 'react'
import MaterialSymbol from '../material-symbol'

const Flag = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="flag" {...props} />
))

Flag.displayName = 'Flag'

export default Flag
